module.exports = __webpack_public_path__ + "img/8-1_Apply_Dimension_Reduction.4d95a9ce.png";